import { AnimatronProject } from 'project';

type IsProjectBigProps = Pick<AnimatronProject, 'version' | 'duration'>;

// const min60 = 60 * 60;
// @ts-ignore
export default ({ version, duration }: IsProjectBigProps) =>
  false;
  // version === 0 && duration > min60;
